<template>
  <div class="schoolRoadTeamPackageadd">
    <div class="header">
      <el-button size="medium" @click="$router.go(-1)">返回</el-button>
      <el-button size="medium" type="primary" @click="updateSchooloverCombo('ruleForm')">保存</el-button>
    </div>
    <div class="body" :style="`height: ${windowHeight - 170}px;`">
       <el-form :model="formData" :rules="rules" ref="ruleForm" label-width="140px" class="demo-ruleForm">
           <el-form-item label="SN" prop="equipmentId">
              <el-input v-model.trim="formData.equipmentId" size="medium" :disabled="true" :maxlength="12" placeholder="请输入SN"></el-input>
            </el-form-item>
            <el-form-item
              label="设备类型"
              prop="equipType"
            >
              <el-select
                v-model="formData.equipType" :disabled="true" 
                placeholder="请选择"
                @change="changeType" size="medium"
              >
                <el-option
                  v-for="item in equipTypelist"
                  :key="item.code"
                  :label="item.value"
                  :value="item.code"
                >
                </el-option>
              </el-select>
            </el-form-item>
            <el-form-item
              label="使用场景"
              prop="useType"
            >
              <el-select
                v-model="formData.useType" :disabled="true" 
                placeholder="请选择" size="medium"
              >
                <el-option
                  v-for="item in useTypelist"
                  :key="item.code"
                  :label="item.value"
                  :value="item.code"
                >
                </el-option>
              </el-select>
               </el-form-item>
            <el-form-item label="学校类型" prop="schoolType">
                <el-select v-model="formData.schoolType" placeholder="请选择学校类型"  :disabled="true"  size="medium" @change="schoolTypefun()">
                    <el-option label="小学" :value="2"></el-option>
                    <el-option label="初中" :value="3"></el-option>
                </el-select>
            </el-form-item>
            <el-form-item label="年级数量" prop="gradeCount">
                <el-select v-model="formData.gradeCount" placeholder="请选择年级数量" size="medium">
                    <el-option label="三年制" :value="3" v-if="formData.schoolType==3"></el-option>
                    <el-option label="四年制" :value="4" v-if="formData.schoolType==3"></el-option>
                    <el-option label="五年制" :value="5" v-if="formData.schoolType==2"></el-option>
                    <el-option label="六年制" :value="6" v-if="formData.schoolType==2"></el-option>
                </el-select>
            </el-form-item>
             <el-form-item label="班级轨数" prop="classCount">
                <el-select v-model="formData.classCount" placeholder="请选择班级轨数" size="medium">
                    <el-option label="4" :value="4"></el-option>
                    <el-option label="5" :value="5"></el-option>
                    <el-option label="6" :value="6"></el-option>
                    <el-option label="7" :value="7"></el-option>
                    <el-option label="8" :value="8"></el-option>
                    <el-option label="9" :value="9" v-if="formData.schoolType==3"></el-option>
                    <el-option label="10" :value="10" v-if="formData.schoolType==3"></el-option>
                    <el-option label="11" :value="11" v-if="formData.schoolType==3"></el-option>
                    <el-option label="12" :value="12" v-if="formData.schoolType==3"></el-option>
                    <el-option label="13" :value="13" v-if="formData.schoolType==3"></el-option>
                    <el-option label="14" :value="14" v-if="formData.schoolType==3"></el-option>
                    <el-option label="15" :value="15" v-if="formData.schoolType==3"></el-option>
                    <el-option label="16" :value="16" v-if="formData.schoolType==3"></el-option>
                </el-select>
            </el-form-item>
           </el-form>
    </div>
  </div>
</template>

<script>
  import windowResize from '@/mixins/windowResize';
  import {findDicsByCode} from '@/api/common/common';
  import {updateSchooloverCombo,getSchooloverCombo} from '@/api/schoolRoadTeamPackage';
  export default {
    data() {
     
      return {        
        formData: {
            cardCount:0,//	放学卡数量	number	
            classCount:4,//		班级数	number	           	
            equipmentId:"",//	设备id （序列号）	string	
            gradeCount:5,//		年级数	number	
            schoolType:2,//	学校类型	number	
            state:1,//		状太1未使作，2已发货，3已使用	number	
            equipType:"",//	设备类型	number	
            equipTypeName:"",//	设备类型名称	string
            useType:"",//	使用类型	number	
            useTypeName:"",//		使用类型名称	string	
        },
        equipTypelist:[],
        useTypelist:[],
        rules: {         
          equipmentId: [{ required: true, trigger: 'blur', message: '请输入SN' }],
          equipType: [{ required: true, message: "请选择设备类型！" }],
          useType: [{ required: true, message: "请选择使用场景！" }],
          classCount: [{ required: true, message: "请选择学校类型！" }],
          gradeCount: [{ required: true, message: "请选择年级数！" }],
          schoolType: [{ required: true, message: "请选择学校类型！" }],
        },
      
      }
    },
    mixins: [windowResize],
    created() {
        getSchooloverCombo(this.$route.query.id)
        .then((res) => {
          const data = res.data.data;
          if (res.data.code === 200) {
              this.formData.cardCount=data.cardCount;
              this.formData.classCount=data.classCount;
              this.formData.equipmentId=data.equipmentId;
              this.formData.gradeCount=data.gradeCount;
              this.formData.schoolType=data.schoolType;
              this.formData.state=data.state;
              this.formData.equipType=data.equipType+"";
              this.formData.useType=data.useType+"";
              this.formData.useTypeName=data.useTypeName;
              this.formData.equipTypeName=data.equipTypeName;
              findDicsByCode({dicCode:"equipType"})
                .then((res) => {
                const data = res.data.data;
                if (res.data.code === 200) {
                    this.equipTypelist = data;
                    this.getUserTypes(this.formData.equipType);
                }
                })
                .catch();
            
          }
        })
        .catch();
         
    },
    methods: { 
        //新增模版
    updateSchooloverCombo(formName) {
      this.$refs[formName].validate(valid => {
        if (valid) {   
          this.formData.cardCount=  this.formData.gradeCount*this.formData.classCount;
          this.formData.useTypeName=this.useTypelist[this.useTypelist.map((item) => item.code).indexOf(this.formData.useType)].value  
          this.formData.equipTypeName=this.equipTypelist[this.equipTypelist.map((item) => item.code).indexOf(this.formData.equipType)].value
          updateSchooloverCombo(this.formData)
            .then(res => {
              const data = res.data;
              if (data.result) {
                this.$message({
                  message: "编辑成功！",
                  type: "success",
                  duration: 1000
                });
                this.$router.go(-1);
              }else{
                    this.$message({
                  message: data.msg,
                  type: "warning",
                  duration: 1000
                });
              }
            })
            .catch(err => {});
        } else {
          return false;
        }
      });
    },
        schoolTypefun(){
            if(this.formData.schoolType==3){
                if(this.formData.gradeCount>4){
                    this.formData.gradeCount=3
                }
            }else{
                if(this.formData.gradeCount<5){
                    this.formData.gradeCount=5
                }
                if(this.formData.classCount>8){
                    this.formData.gradeCount=4
                }
            }
        },
    changeType(val) {
      this.getUserTypes(val);
    },    
     getUserTypes(code) {
      findDicsByCode({dicCode:code})
        .then((res) => {
          const data = res.data.data;
          if (res.data.code === 200) {
            this.useTypelist = data;
          }
        })
        .catch();
    },
    }
  }
</script>
<style lang="scss" scoped>
  .schoolRoadTeamPackageadd{
    padding: 12px;
    *{
        box-sizing: border-box;
    }
    .header {
      padding-bottom: 10px;
      border-bottom: 1px solid #eee;
    }
    .body{
     overflow: auto;
     .demo-ruleForm{
         margin: 10px auto;
         width: 810px;
         .el-select{
             width: 100%;
         }
     }
    }
  }
</style>



// WEBPACK FOOTER //
// src/views/schoolRoadTeamPackage/schoolRoadTeamPackageeidt.vue